import { render, staticRenderFns } from "./TransferVaultActionView.vue?vue&type=template&id=274a51d2&"
import script from "./TransferVaultActionView.vue?vue&type=script&lang=js&"
export * from "./TransferVaultActionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports